import React, { useEffect, useState } from 'react';
import Form, { useForm } from '../../molecules/Form';
import Field from '../Field';
import Button from '../../molecules/Button';
import Toast from '../../molecules/Toast';
import iconFile from '../../../assets/icon-csv-file.svg';
import { useContextHook } from 'use-context-hook';
import { AuthContext } from '../../../Context/authContext';
import leadService from '../../../services/leadService';
import linkedinService from '../../../services/linkedinService';
import bkaclistService from '../../../services/blacklistService';
import { getLinkedInScrapeLeadLimit, getLinkedInScrapeUrlType, handleOnDrop } from '../../../helpers/common';
import { TabsWrap } from '../CreateCompaign/CreateCompaign.styles';
import TagSelector from '../TagSelector/TagSelector';
import { FaLinkedin } from 'react-icons/fa';
import selectArrow from '../../../assets/arrow-down-img.svg';

const UploadLeads = ({
  setData,
  addLeadsDataTab,
  setAddLeadsDataTab,
  setOpenLeadsModal,
  setCsvInfo,
  activeTab,
  setActiveTab,
}) => {
  const [form] = useForm();
  const [formData, setFormData] = useState(null);
  const [selectedTag, setSelectedTag] = useState(null);
  const [linkedInProfiles, setLinkedInProfiles] = useState(false);
  const [scrapingLoading, setScrapingLoading] = useState(false);

  const [searchQuery, setSearchQuery] = useState({ id: 2, filterStatus: 'SUCCEEDED', agent_type: 'email' });
  const { user, fetch, refetch } = useContextHook(AuthContext, v => ({
    user: v.user,
    fetch: v.fetch,
    refetch: v.refetch,
  }));
  const { domains_loading, domains_data } = bkaclistService.GetAllBlacListDomain(searchQuery, fetch);
  useEffect(() => {
    fetchLinkedinProfiles();
  }, []);

  const fetchLinkedinProfiles = async () => {
    try {
      const payload = {
        status: 'active',
      };
      const res = await linkedinService.getAllUserProfileData(payload);
      if (res?.success) {
        setLinkedInProfiles(res?.data);
      }
    } catch (error) {
      Toast({
        type: 'error',
        message: error.message || 'Failed to fetch LinkedIn profiles',
      });
    }
  };

  const { agent_data } = leadService.GetAgent(searchQuery, searchQuery?.id, fetch);
  const houdinyLeads = agent_data?.data?.items?.map(i => ({
    label: i.task_name,
    value: i.task_name,
    out_csv: i.output_csv,
    task_id: i.id,
  }));
  const linkedinProfilesOptions = linkedInProfiles
    ? linkedInProfiles?.filter(profile => profile?.isLoggedIn === true)?.map(profile => ({
      label: profile.firstName + ' ' + profile.lastName,
      value: profile.id,
    }))
    : [];

  const handelSubmit = async e => {
    const step1Data = {
      ...e,
      rowLenght: formData?.rowData,
      columnNames: formData?.columnNames,
      rows: formData?.rows,
      tag: selectedTag, // Store selected tag
    };

    if (activeTab === 'linkedin') {

      const payload = {
        tab: activeTab,
        job_name: e.list_name,
        tagId: selectedTag,
        profileId: e.account.value,
        url: e?.scrape_url?.trim(),
        numOfLeads: parseInt(e?.leads_to_scrape, 10) || 0,
      };
      setScrapingLoading(true);
      try {
        const res = await linkedinService.linkedinScraping(payload);

        if (res?.success) {
          Toast({
            type: 'success',
            message: res.message,
          });
          setOpenLeadsModal(false);
          refetch();
        }
      } catch (error) {
        Toast({ type: 'error', message: error?.message || 'Something went wrong!' });
      } finally {
        setScrapingLoading(false);
      }

      return;
    }

    setData(prev => ({
      ...prev,
      step1: {
        ...step1Data,
        domains_data, // Store domains_data for use in mapping step
      },
    }));

    if (addLeadsDataTab === 'leads') {
      const totalRows = formData?.rows?.length || 0;

      if (totalRows === 0) {
        Toast({
          type: 'error',
          message: 'CSV has no data rows. Please upload a valid file.',
        });
        return;
      }
      setCsvInfo({
        blockedEmails: formData?.blockedRows || [],
        duplicateEmails: formData?.duplicateEmails || [],
        totalContacts: formData?.totalContacts || [],
        totalEmails: formData?.totalEmails || [],
      });
      setAddLeadsDataTab('mapping');
    } else if (addLeadsDataTab === 'mapping') {
      setAddLeadsDataTab('leadsData');
    }
  };

  return (
    <Form
      className="form-area"
      form={form}
      onSubmit={handelSubmit}
      onTouched={changed => {
        if (changed && Object.hasOwn(changed, 'scrape_url')) {
          const leads = form.getFieldValue('leads_to_scrape');
          if (leads !== undefined && leads !== '') {
            form.setFieldsValue({ leads_to_scrape: leads });
          }
        }
      }}>
      <div className="column-wrap">
        <div className="left-col">
          <div className="head">
            <div>
              <span className="heading">Create Leads Import</span>
              <p>Name your Import and select your data source. Upload a CSV or scrape LinkedIn.</p>
            </div>
          </div>
          <Form.Item
            colorBg
            inputSm
            type="text"
            label="Name Your Import"
            name="list_name"
            placeholder="Name"
            rules={[
              {
                required: true,
                message: 'Name is required',
              },
            ]}>
            <Field />
          </Form.Item>

          <TagSelector selectedTag={selectedTag} setSelectedTag={setSelectedTag} />
          <TabsWrap>
            <span className="title">Lead Source</span>
            <div className="tabs-btns">
              <button
                type="button"
                className={`tabBtn ${activeTab === 'linkedin' ? 'active' : ''}`}
                onClick={() => setActiveTab('linkedin')}>
                <div className="btn-content">
                  <div className="icon-box">
                    <FaLinkedin color="#0066C8" size={25} />
                  </div>
                  <div className="text-box">
                    <span className="subtitle">Import Leads</span>
                    <span className="title">LinkedIn</span>
                  </div>
                  <span className="ico-tick" />
                </div>
              </button>
              <button
                type="button"
                className={`tabBtn ${activeTab === 'csv' ? 'active' : ''}`}
                onClick={() => setActiveTab('csv')}>
                <div className="btn-content">
                  <div className="icon-box">
                    <img src={iconFile} width="25px" alt="file" />
                  </div>
                  <div className="text-box">
                    <span className="subtitle">Upload</span>
                    <span className="title">CSV File</span>
                  </div>
                  <span className="ico-tick" />
                </div>
              </button>
            </div>
            <div className="tab-content">
              {/* CSV Upload tab */}
              {activeTab === 'csv' && (
                <div className="content01">
                  <Form.Item
                    type="csv"
                    label="Upload your CSV file"
                    rounded
                    name="csvfile"
                    placeholder="csv file"
                    rules={[
                      {
                        required: true,
                        message: 'File is required to continue',
                      },
                    ]}
                    bg
                    disc="Drag & Drop or choose file to upload . Limit 200MB per file • CSV"
                    uploadTitle="Drag & Drop or choose file to upload"
                    fileSize={20}
                    icon
                    accept=".xlsx , .csv"
                    onUploadAccepted={(rawData, file) => {
                      handleOnDrop(rawData, file, user, setFormData, form, Toast, domains_data);
                    }}
                    onRemove={() => {
                      form.setFieldsValue({ csvfile: '' });
                    }}>
                    <Field />
                  </Form.Item>
                </div>
              )}

              {/* Scrape CSV tab */}
              {activeTab === 'linkedin' && (
                <div className="content01">
                  <Form.Item
                    label="Select Profile"
                    type="select"
                    options={linkedinProfilesOptions}
                    colorBg
                    selectSm
                    rounded
                    name="account"
                    rules={[
                      {
                        required: true,
                        message: 'Please select a profile',
                      },
                    ]}>
                    <Field />
                  </Form.Item>
                  <div className="input-holder">
                    <Form.Item
                      colorBg
                      inputSm
                      type="text"
                      label="Url Link"
                      noMargin
                      name="scrape_url"
                      placeholder="https://www.linkedin.com/search/results/people/..."
                      rules={[
                        {
                          required: true,
                          message: 'Source URL is required',
                        },
                        {
                          transform: value => !getLinkedInScrapeUrlType(value),
                          message:
                            'Enter a LinkedIn search URL (linkedin.com/search/results/...) or Sales Navigator URL (linkedin.com/sales/...)',
                        },
                      ]}>
                      <Field />
                    </Form.Item>
                    <Form.Item
                      colorBg
                      inputSm
                      type="number"
                      label="How many leads you want to scrape?"
                      noMargin
                      name="leads_to_scrape"
                      placeholder="Enter leads to scrape"
                      rules={[
                        {
                          required: true,
                          message: 'Please enter the number of leads to scrape',
                        },
                        {
                          min: 1,
                          message: 'Enter at least 1 lead',
                        },
                        {
                          transform: value => {
                            const num = Number(value);
                            if (value === '' || value == null || Number.isNaN(num)) return false;
                            const limit = getLinkedInScrapeLeadLimit(form.getFieldValue('scrape_url'));
                            if (!limit) return false;
                            return num > limit;
                          },
                          message:
                            'Maximum is 500 leads for LinkedIn search URLs and 2000 for Sales Navigator URLs',
                        },
                      ]}>
                      <Field />
                    </Form.Item>
                  </div>
                </div>
              )}
              {activeTab === 'linkedin' && (
                <div className="note-box">
                  <span className="text">Note:</span> The maximum lead scraping limit is 500 for basic LinkedIn
                  accounts and 2000 for LinkedIn Sales Navigator.
                </div>
              )}
            </div>
          </TabsWrap>
        </div>
      </div>
      <div className="edit-btn-holder">
        <Button newStyle variant="outline" width="155px" rounded type="button" onClick={() => setOpenLeadsModal(false)}>
          Cancel
        </Button>
        <Button
          newStyle
          rounded
          variant="darkBlue"
          type="submit"
          width="155px"
          loader={activeTab === 'linkedin' ? scrapingLoading : ''}
          disabled={activeTab === 'linkedin' ? scrapingLoading : false}
        >
          {activeTab === 'linkedin' ? 'Finish' : 'Next'}
        </Button>
      </div>
    </Form>
  );
};

export default UploadLeads;
